import { AlertCP } from 'main/common/components/alert/AlertCP'
import { ButtonCP } from 'main/common/components/button/ButtonCP'
import { TextCP } from 'main/common/components/text/TextCP'
import { UploadStateTP } from 'main/modules/sales-funnel/components/modal-lead-import/inner/types/UploadStateTP'
import React from 'react'
import styled from 'styled-components'

interface IAlertValidationStatusICPProps {
    uploadState: UploadStateTP
    onCheckErrorsClick: () => void
}

/**
 * COMPONENTE
 * Retorno visual apos conclusao de 01 tentativa de importacao de arquivo no modal de importacao de leads.
 *
 * @see PersonImportModalCP
 */
export function AlertValidationStatusICP(props: IAlertValidationStatusICPProps): JSX.Element {
    switch (props.uploadState) {
        case 'success':
            return (
                <AlertCP
                    message={'Yes!'}
                    type={'success'}
                    description={'Já validamos e está tudo certinho com a planilha. A importação está em andamento'}
                />
            )

        case 'failure':
            return (
                <AlertCP
                    message={'Ops!'}
                    type={'warning'}
                    description={
                        <FailureAlertSCP>
                            <p>
                                Encontramos inconsistências na planilha. Favor corrigí-las e fazer upload novamente.
                            </p>

                            <ButtonCP type={'link'} onClick={props.onCheckErrorsClick}>
                                <TextCP size={'small'} text={'Ver inconsistências'}/>
                            </ButtonCP>
                        </FailureAlertSCP>
                    }
                />
            )

        case 'error':
        default:
            return (
                <AlertCP
                    message={'Ops!'}
                    type={'error'}
                    description={'Falha ao tentar validar arquivo. Por favor, tente novamente.'}
                />
            )
    }
}

const FailureAlertSCP = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`
